import { FileTextIcon } from '@phosphor-icons/react'

export const exportInventoryValues = {
  existingCsv: 'existing_csv',
  exportCurrentInventory: 'export_current_inventory',
}

export const exportInventoryOptions = [
  {
    label: 'Ya tengo un archivo de inventario actualizado',
    value: exportInventoryValues.existingCsv,
  },
  {
    label: 'Necesito descargar un nuevo archivo de inventario',
    value: exportInventoryValues.exportCurrentInventory,
  },
]

export const exportTemplateValues = {
  globalInventory: 'inventory_items',
  exportPrices: 'inventory_export_prices',
}

export const exportTemplateOptions = [
  {
    value: exportTemplateValues.globalInventory,
    label: 'Inventario global',
    description: 'Catálogo completo de productos con todos los campos',
    Icon: FileTextIcon,
  },
  {
    value: exportTemplateValues.exportPrices,
    label: 'Precios de exportación',
    description: 'Precio por país para cada variante',
    Icon: FileTextIcon,
  },
]

export const maxExportEmails = 10
